"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var flattenDeep_1 = require("../../utils/flattenDeep");
var hasLocalStorage_1 = require("../../utils/hasLocalStorage");
var toKeyValueArray_1 = require("../../utils/toKeyValueArray");
var toValueArray_1 = require("../../utils/toValueArray");
var AcceptedCookiesStrategy_1 = require("../AcceptedCookiesStrategy");
var StorageKeys;
(function (StorageKeys) {
    StorageKeys["ACCEPTED_COOKIES"] = "acceptedCookies";
    StorageKeys["LAST_VERSION"] = "last-js-version";
    StorageKeys["LAST_UPDATE"] = "last-cookie-info-update";
})(StorageKeys || (StorageKeys = {}));
var LocalStorageAcceptedCookies = /** @class */ (function (_super) {
    __extends(LocalStorageAcceptedCookies, _super);
    function LocalStorageAcceptedCookies(INTERNAL_API_URL, VERSION_FILES_JS, $Cookies) {
        var _this = _super.call(this, INTERNAL_API_URL, VERSION_FILES_JS) || this;
        _this.saveCookiesDictionary = function (acceptedCookies, cookiesDictionary) {
            _this.saveAcceptedCookies(_this.cookiesDictionaryToFlatArray(acceptedCookies, cookiesDictionary));
        };
        _this.deleteNotPermittedCookies = function (allowedCookies) {
            var allCookies = document.cookie.split(";");
            allCookies.forEach(function (cookie) {
                var cookieName = cookie.split("=")[0].trim();
                if (!_this.IsAllowed(cookieName, allowedCookies)) {
                    _this.$Cookies.Delete(cookieName);
                }
            });
        };
        _this.$Cookies = $Cookies;
        return _this;
    }
    LocalStorageAcceptedCookies.prototype.GetLastVersion = function () {
        var cookieValue = parseInt(this.GetItemLocalStorage(StorageKeys.LAST_VERSION));
        return !isNaN(cookieValue) ? cookieValue : null;
    };
    LocalStorageAcceptedCookies.prototype.GetLastUpdateTime = function () {
        var cookieValue = this.GetItemLocalStorage(StorageKeys.LAST_UPDATE);
        return cookieValue ? new Date(cookieValue) : null;
    };
    LocalStorageAcceptedCookies.prototype.Get = function (acceptedCategories) {
        return JSON.parse(this.GetItemLocalStorage(StorageKeys.ACCEPTED_COOKIES));
    };
    LocalStorageAcceptedCookies.prototype.SaveAcceptedCookies = function (acceptedCookies) {
        this.saveAcceptedCookies(acceptedCookies);
        this.deleteNotPermittedCookies(acceptedCookies);
        this.setLastUpdate();
        this.setLastVersion();
    };
    LocalStorageAcceptedCookies.prototype.setLastVersion = function () {
        this.SetItemLocalStorage(StorageKeys.LAST_VERSION, this.VERSION_FILES_JS.toString());
    };
    LocalStorageAcceptedCookies.prototype.setLastUpdate = function () {
        this.SetItemLocalStorage(StorageKeys.LAST_UPDATE, new Date().toUTCString());
    };
    LocalStorageAcceptedCookies.prototype.saveAcceptedCookies = function (acceptedCookies) {
        this.SetItemLocalStorage(StorageKeys.ACCEPTED_COOKIES, JSON.stringify(acceptedCookies));
    };
    LocalStorageAcceptedCookies.prototype.cookiesDictionaryToFlatArray = function (acceptedCategories, cookiesDictionary) {
        var isCategoryAccepted = function (categoryName) { return acceptedCategories[categoryName]; };
        return flattenDeep_1.default(toKeyValueArray_1.default(cookiesDictionary)
            .filter(function (_a) {
            var key = _a.key;
            return isCategoryAccepted(key);
        })
            .map(function (_a) {
            var value = _a.value;
            return toValueArray_1.default(value);
        }));
    };
    LocalStorageAcceptedCookies.prototype.SetItemLocalStorage = function (key, value) {
        if (hasLocalStorage_1.default) {
            try {
                window.localStorage.setItem(key, value);
            }
            catch (e) {
                console.error("Error saving " + key + " to localStorage");
            }
        }
        else {
            // Falling back to cookies
            this.$Cookies.Set(key, value, 24 * 365);
        }
    };
    LocalStorageAcceptedCookies.prototype.GetItemLocalStorage = function (key) {
        if (hasLocalStorage_1.default) {
            return window.localStorage.getItem(key);
        }
        return this.$Cookies.Get(key);
    };
    return LocalStorageAcceptedCookies;
}(AcceptedCookiesStrategy_1.default));
exports.default = LocalStorageAcceptedCookies;
//# sourceMappingURL=LocalStorageAcceptedCookies.js.map